import RestResource from '../rest.service';

export default class ProvincesService extends RestResource {
  constructor() {
    super('provinces');
  }
}
